import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { exportToExcel } from "../utils/exportToExcel";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import api from "../api/axios";
import Loader from "./Loader";
import { companyID } from "../auth";

const EmployeeSalaryToExcel = ({
  show,
  handleClose,
  employeesSalary,
  setEmployeesSalary,
  fetchEmployeesSalary,
  error,
  setError,
  sendEmail = false,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loader, setLoader] = useState({
    show: false,
    message: "",
  });
  const company_id = companyID();
  const employee_id = localStorage.getItem("employeeID");

  useEffect(() => {
    setSelectedDate(new Date());
  }, [show]);

  const formatSalaryData = (employeesSalary) => {
    return employeesSalary.map((item) => ({
      Name: `${item.first_name} ${item.middle_name || ""} ${
        item.last_name
      }`.trim(),
      Month: item.month,
      "Net Salary": item.net_salary,
      "Account number": item.account_number,
      "Bank name": item.bank_name,
      "IFSC code": item.ifsc_code,
      "Branch name": item.branch_name,
      "Phone Number": item.number,
    }));
  };

  const getYearMonth = (selectedDate) => {
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const handleDownload = () => {
    const data = formatSalaryData(employeesSalary);
    const fileName = `Salary Details-${getYearMonth(selectedDate)}`;
    exportToExcel(data, fileName)
      .then((successMessage) => {
        Swal.fire({
          title: "Salary Excel",
          text: successMessage,
          icon: "success",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      })
      .catch((errorMessage) => {
        Swal.fire({
          title: "Salary Excel",
          text: errorMessage,
          icon: "warning",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-warning",
          },
        });
      })
      .finally(() => {
        setEmployeesSalary([]);
        handleClose();
      });
  };

  const handleSendEmail = async () => {
    handleClose();
    setLoader({
      show: true,
      message: "Sending salary report to management...",
    });
    const salary_month = getYearMonth(selectedDate);
    const data = formatSalaryData(employeesSalary);
    const fileName = `Salary Details-${salary_month}`;
    try {
      const salaryReport = await exportToExcel(data, fileName, true);
      const formData = new FormData();
      formData.append("salary_report", salaryReport, `${fileName}.xlsx`);
      formData.append("salary_month", salary_month);

      const result = await api.post(
        `send-salary-email/${employee_id}/${company_id}`,
        formData
      );

      Swal.fire({
        title: "Email Sent",
        text: result.message,
        icon: "success",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    } catch (error) {
      Swal.fire({
        title: "Email Error",
        text: error.message,
        icon: "warning",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    } finally {
      setLoader({ show: false, message: "" });
      setEmployeesSalary([]);
    }
  };
  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static" centered>
        <Modal.Header>
          <Modal.Title>Employees Salary Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-baseline justify-content-between">
            <p className="w-50">Select Month</p>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => {
                if (date) {
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  setSelectedDate(date);
                  fetchEmployeesSalary(`${year}-${month}`);
                }
              }}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="form-control"
            />
          </div>
          {error?.salaryDetails && (
            <span className="text-danger">* {error?.salaryDetails}</span>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
              setError((prev) => ({ ...prev, salaryDetails: null }));
            }}
          >
            Close
          </Button>
          <Button
            variant="success"
            className="btn-primary"
            disabled={employeesSalary.length <= 0 ? true : false}
            onClick={handleDownload}
          >
            <i
              className="fa-solid fa-download me-1"
              title="Download excel file"
            ></i>
            Download
          </Button>
          {sendEmail && (
            <Button
              variant="success"
              className="btn-primary"
              disabled={employeesSalary.length <= 0 ? true : false}
              onClick={handleSendEmail}
            >
              <i
                class="fa-solid fa-envelope me-1"
                title="Send mail to management"
              />
              Send mail
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {loader.show && (
        <Loader show={loader.show} loadingMessage={loader.message} />
      )}
    </>
  );
};

export default EmployeeSalaryToExcel;
